import React, { useEffect } from "react";
import { AlertAction, AlertDialogue, EmptyTable, GridContainer, GridItem, SimpleTable } from "@dclab/dc-react-ui-kit";
import Moment from "moment";
import Handle from "../../../assets/img/more_vert-24px.svg";
import { EditNewsAndArticlesWebsite, GetNewsAndArticlesWebsiteFeatured, getNewsWithAppId, sortNewsArticlesWebsite, updateNewsWithAppId } from "../../../pages/Website/api";
import { CircularProgress } from "@material-ui/core";
import { connect } from "react-redux";
import { hideAlert, showAlert } from "../../../redux/actions/alertActions";
import messages_content from '../../../utils/messages.json';
import { editOrganization } from "../../../pages/Organization/api";
const { 
    token_expired,
    new_unfeatured_successfully
  } = messages_content;
function NewsArticles(props) {
  const [DataTable, setDataTable] = React.useState([]);
  const [Loader, setLoader] = React.useState(true);
  const [specificRow, setSpecificRow] = React.useState([]);
  const [openAlert, setOpenAlert] = React.useState(false);
  const [data, setData] = React.useState([]);
  const [orgData, setOrgData] = React.useState({})
  const [error, seterror] = React.useState(false)
  let classProps = () => {
    const tempArray = [];
    col.forEach((column, index) => {
      tempArray.push(`class${index}`);
    });
    return tempArray;
  };
  useEffect(() => {
    setOrgData(props.organization.orgData)
  }, [props.organization])
  useEffect(() => {
    getFeaturedNews()
  }, [])
  async function getFeaturedNews() {
    const token = localStorage.getItem("authToken");
    const orgId = localStorage.getItem('orgID');
    try {
      const resNews = await getNewsWithAppId(token, orgId, 'deenweb')
      const data = resNews.data.body.data;
      const filterFeatured = data.filter(text => text.featured)
      const sort = filterFeatured.sort((a, b) => {
        return a.article.order - b.article.order
      })
      setData(sort)
      let dataTable = [];
      sort.map((text, index) => {
        const dateStart = [Moment(text.publishFrom).format("MMM DD, YYYY"), Moment(text.publishFrom).format("h:mm A") + ' (EST)'];
        const dateEnd = [Moment(text.publishTo).format("MMM DD, YYYY"), Moment(text.publishTo).format("h:mm A") + ' (EST)'];
        const UnpublishDate = new Date(dateEnd).getFullYear()
        let array = [
          { type: "id", value: `${index<=8 ? '0'+(index+1) : index + 1}`, _id: text._id, newsId: text.article._id },
          {
            type: "url",
            name: "single_pic",
            src: text.article.imageMetaData ? text.article.imageMetaData.imageUrl : '',
          },
          {
            type: "string",
            name: "name",
            value: text.article.title,
          },
          { type: "string", name: "frequency", value: text.article.category },
          {
            type: "string",
            name: "vertical",
            value: dateStart,
          },
          {
            type: "string",
            name: UnpublishDate === 2099 ? "frequency" : "vertical",
            value: UnpublishDate === 2099 ? "Never" : dateEnd
          },
          { type: "action", status: "details", value: "Remove" },
        ]
        dataTable.push(array)
      })
      setDataTable(dataTable);
      setLoader(false);
    } catch (err) {
      setLoader(false);
      seterror(err.response && err.response.data.message)
      setTimeout(() => {
        seterror(false)
      }, 8000);
    }
  }
  const changeClassProps = () => {
    const tempArray = classProps();
    tempArray[0] = "class15";
    return tempArray;
  };
  let col = [
    { id: "drag", label: " ", width: 'auto' },
    { type: "number", name: "serial_number", label: "NO.", width: 'auto' },
    { type: "link", name: "invoice_number", label: "Image", width: 'auto' },
    { type: "string", name: "name", label: "Title", width: '30%' },
    { type: "string", name: "date", label: "Category", width: '20%' },
    { type: "string", name: "date/time", label: "Publish Date", width: '20%' },
    {
      type: "string",
      name: "date/time",
      label: "UnPublish Date",
      width: '20%',
    },
    { type: "action", name: "action", label: "ACTION", width: '10%' },
  ];
  const DeleteAlertFunc = (e) => {
    setSpecificRow(e);
    setOpenAlert(true);
  }
  const handleCancel = () => {
    setOpenAlert(false);
  }
  const handleClose = () => {
    setOpenAlert(false);
  };
  const RemoveRow = async (e) => {
    setOpenAlert(false);
    setLoader(true);
    const token = localStorage.getItem("authToken");
    const orgId = localStorage.getItem('orgID');
    const updateOnOrg = {
      article: e[0].newsId,
      featured: false,
      publishFrom: data[0].publishFrom,  // DATE OBJECT
      publishTo: data[0].publishTo,
      status: data[0].status,
  }
    try {
      await updateNewsWithAppId(token, orgId, 'deenweb', e[0].newsId, updateOnOrg )
      props.alertShow(new_unfeatured_successfully)
      const stateNews = DataTable
      const NewsIndex =  DataTable.indexOf(e)
      stateNews.splice(NewsIndex, 1)
      setLoader(false);
    } catch (err) {
      setLoader(false);
      seterror(err.response && err.response.data.message)
      setTimeout(() => {
        seterror(false)
      }, 8000);
    }
  }
  const style = {
    width: 470,
    marginLeft: 800
  };
  const sortData = async (data) => {
    props.setCheckChanges(true)
    const token = localStorage.getItem("authToken");
    const OBJ = {
      sortedList: data.map(text => {
        return (
          { _id: text?.article?._id, order: text.order }
        )
      })
    }
    try {
      await sortNewsArticlesWebsite(token, OBJ)
    } catch (err) {
      seterror(err.response && err.response.data.message)
      setTimeout(() => {
        seterror(false)
      }, 8000);
    }
    const sortedData = data.sort((a, b) => a.order - b.order)
    let arr = []
    sortedData.map((text, index) => {
      const dateStart = [Moment(text.publishFrom).format("MMM DD, YYYY"), Moment(text.publishFrom).format("h:mm A") + ' (EST)'];
      const dateEnd = [Moment(text.publishTo).format("MMM DD, YYYY"), Moment(text.publishTo).format("h:mm A") + ' (EST)'];
      const UnpublishDate = new Date(dateEnd).getFullYear()
      let array = [
        { type: "id", value: `${index<=8 ? '0'+(index+1) : index + 1}`, _id: text._id, newsId: text.article._id },
        {
          type: "url",
          name: "single_pic",
          src: text.article.imageMetaData ? text.article.imageMetaData.imageUrl : '',
        },
        {
          type: "string",
          name: "name",
          value: text.article.title,
        },
        { type: "string", name: "frequency", value: text.article.category },
        {
          type: "string",
          name: "vertical",
          value: dateStart,
        },
        {
          type: "string",
          name: UnpublishDate === 2099 ? "frequency" : "vertical",
          value: UnpublishDate === 2099 ? "Never" : dateEnd
        },
        { type: "action", status: "details", value: "Remove" },
      ]
      arr.push(array)
    })
    setDataTable(arr);
  };
  return (
    <GridContainer containerClass="web-announcements ">
      {
        Loader ?
          <div
            style={{
              marginTop: 30,
              display: "flex",
              justifyContent: "center",
            }}
          >
            <CircularProgress color="primary" />
          </div>
          :
          DataTable.length > 0 ?
            <>
              {
                error && error === "Invalid token" && (
                  <div style={{ zIndex: 9999, width: "60%", position: "fixed", top: 35, marginLeft: '17px' }}>
                    <AlertAction
                      alert={token_expired}
                      alertType={"error"}
                      onClick={() => seterror(false)}
                    />
                  </div>
                )
              }
              <GridItem xs={12}>
                <SimpleTable
                  showHeader={true}
                  title="Featured Reads/Views" 
                  parentTableDrag={true}
                  DragIcon={Handle}
                  rows={DataTable}
                  columns={col}
                  colSpan={16}
                  actionSendButton={true}
                  actionLink={(e) => DeleteAlertFunc(e)}
                  classProps={changeClassProps()}
                  donationsCount={DataTable?.length ? 1 : 0}
                  noTitle="No Reads/Views added"
                  noPara="Added Reads/Views will be displayed and managed here"
                  noBtnText="Add New Reads/Views"
                  onInviteClick={() =>
                    props.history.push("/website/homepage/add-news-articles")
                  }
                  showIconCol={false}
                  showFooter={false}
                  showAdd={true}
                  addText="ADD"
                  onAddClick={() =>
                    props.history.push("/website/homepage/add-news-articles")
                  }
                  iconTextSize={16}
                  sortData={(e) => sortData(e)}
                  sortColumnIndex={[5]}
                  data={data}
                />
                <div style={{ display: "flex", marginTop: 20 }}>
                  <p className="cat-lower" style={{ marginTop: 0 }}>Change the order of Reads/Views to display to users. Click on{" "}</p>
                  <img src={Handle} alt="" style={{ display: "flex", marginTop: -10 }} />
                  <p className="cat-lower" style={{ marginTop: 0 }}> to drag and drop within the table.</p>
                </div>
              </GridItem>
            </>
            :
            <EmptyTable 
              title="Featured Reads/Views" onAddClick={() => props.history.push("/website/homepage/add-news-articles")}
              addLabel="Add"
              noBtnText="Add" 
            />
      }
      <div>
        <AlertDialogue
          title="Remove Reads/Views?"
          description="Are you sure you want to remove this read/view?"
          description2 = "It will be removed from homepage only."
          cancelText="Cancel"
          confirmText="Confirm"
          open={openAlert}
          handleCancel={() => handleCancel()}
          handleClose={() => handleClose()}
          handleConfirm={() => RemoveRow(specificRow)}
          styles={style}
        />
      </div>
    </GridContainer>
  );
}
const mapStateToProps = (state) => ({
  alert: state.addOrg.alert,
  organization: state.orgData

});
const mapDispatchToProps = (dispatch) => ({
  alertShow: (res) => dispatch(showAlert(res)),
  alertHide: (res) => dispatch(hideAlert(res)),

});
export default connect(mapStateToProps, mapDispatchToProps)(NewsArticles);
